import React from 'react';
import ReactDOM from 'react-dom/client';
import './styles/index.scss';
import App from './App';
import reportWebVitals from './reportWebVitals';
import Modal from 'react-modal';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import { HyperFormula } from 'hyperformula';
// @ts-expect-error
import frFR from 'hyperformula/i18n/languages/frFR';
// @ts-expect-error
import ptPt from 'hyperformula/i18n/languages/ptPT';
import './common/extensions/stringExtension';
import 'dayjs/locale/pt';
import 'dayjs/locale/fr';
import 'moment/locale/fr';
import 'moment/locale/pt';

HyperFormula.registerLanguage('frFR', frFR);
HyperFormula.registerLanguage('ptPT', ptPt);

dayjs.extend(utc);
dayjs.extend(timezone);

Modal.setAppElement('#root');

const root = ReactDOM.createRoot(
    document.getElementById('root') as HTMLElement
);
root.render(
    <App />
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
